import config from 'config';

const LOAD_COMPETITION = 'football/competitions/LOAD_COMPETITION';
const LOAD_COMPETITION_SUCCESS = 'football/competitions/LOAD_COMPETITION_SUCCESS';
const LOAD_COMPETITION_FAIL = 'football/competitions/LOAD_COMPETITION_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_COMPETITION:
      return {
        ...state,
        loading: true
      };
    case LOAD_COMPETITION_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        selectedCompetition: action.result
      };
    }
    case LOAD_COMPETITION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.football
      && globalState.football.competition
      && globalState.football.competition.loading;
}

export function loadCompetition(competitionId) {
  return {
    types: [LOAD_COMPETITION, LOAD_COMPETITION_SUCCESS, LOAD_COMPETITION_FAIL],
    promise: client => client.get(`${config.api.football.competitions}/${competitionId}`)
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/competition.js